import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_4bdbb331-5a71-48db-887b-1d17bd108d27/artifacts/1fuqcwp7_PFP_DETAILING.png";

const links = [
  { label: "Services", id: "services" },
  { label: "Ethos", id: "manifesto" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

export const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-black/60 backdrop-blur-2xl border-b border-white/10" : "border-b border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO} alt="Habibz Detailing" className="h-12 w-12 object-contain" />
          <span className="hidden sm:block font-display text-lg tracking-tight text-white leading-none">
            HABIBZ<span className="text-[#3377ff]">DETAILING</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={onBook}
          data-testid="nav-book-btn"
          className="cta-sharp group flex items-center gap-2 bg-[#0055ff] hover:bg-[#3377ff] text-white px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em]"
        >
          <Phone size={14} /> Book Now
        </button>
      </div>
    </motion.header>
  );
};
